import { CAT_CUSTOMERS } from 'App/utils/Collections';

export default {
  category: CAT_CUSTOMERS,
  filters: [],
  searchBarProp: 'complex_name',
};
